<template>
  <div class="main-slider-bullet js-slider-bullet">
    <span class="main-slider-bullet__text js-slider-bullet__text">{{bulletIndex}}</span>
    <span class="main-slider-bullet__line js-slider-bullet__line"></span>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    bulletIndex() {
      return `0${this.index}`;
    }
  }
};
</script>